import { useTheme } from '@mui/material/styles';

export const HeaderStyles = () => {
  const theme = useTheme();

  return {
    alignItems: "center",
    background: theme.palette.primary.main,
    border: "none",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: "10px 30px 10px 20px",
    '& .Header__pageTitle': {
      color: 'white',
      fontSize: "1.4rem",
      margin: '0',
      textAlign: "center",
      width: {
        xs: "100%",
        sm: "auto",
      }
    },
    '& .Header__profile': {
      display: {
        xs: 'none',
        sm: 'block',
      }
    },
    '& .Header__profile .UserProfile__name': {
      color: "white"
    }
  }
}
